import 'whatwg-fetch';
import { saveAs } from 'file-saver';
import { checkIfBase64, convertBase64ToBlobUrl } from './';

export function downloadFromUrl(url, fileName) {
  // Note: we need to send the Cache-Control header when
  // downloading the file from S3 because when the same
  // presigned URL is loaded into the FileViewer, the
  // browser caches the request and results in a CORS
  // error when making the same request.
  fetch(url, {
    method: 'GET',
    headers: {
      'Cache-Control': 'no-cache',
    },
  })
    .then(res => res.blob())
    .then((blob) => {
      saveAs(blob, fileName);
    });
}

export function setFileUrl(url) {
  // HACK: there is currently a bug with the file viewer in IE 11
  // that prevents some base64 encoded files from being displayed.
  // As a workaround, convert the string to a blob URL beforehand.
  return url && checkIfBase64(url) ? convertBase64ToBlobUrl(url) : url;
}



// WEBPACK FOOTER //
// ./src/helpers/fileDownloader.js